'use client';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/GlobalRedux/store';

const initialState: boolean = false;

const logoutRequested = createSlice({
  name: 'logoutRequested',
  initialState,
  reducers: {
    setLogoutRequested: (_state, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setLogoutRequested } = logoutRequested.actions;
export default logoutRequested.reducer;
export const logoutRequestedSelector = (state: RootState) =>
  state.logoutRequested;
